import { render, staticRenderFns } from "./CollaborationAccountRead.vue?vue&type=template&id=c3f243d6&scoped=true&"
import script from "./CollaborationAccountRead.vue?vue&type=script&lang=js&"
export * from "./CollaborationAccountRead.vue?vue&type=script&lang=js&"
import style0 from "./CollaborationAccountRead.vue?vue&type=style&index=0&id=c3f243d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f243d6",
  null
  
)

export default component.exports